import React from "react";

import {getBackground, StoreOption} from "../common";
import SkillOption from "../common/SkillOption";
import './Home.css'

/* global BigInt */

export default class Home extends React.Component {
	bonusFormat = (bonus) => {
		switch (bonus) {
			case 'incByClic': return 'For each click'
			default: return ''
		}
	}

	statsTextFormat = (title, bonus, value) => {
		return <div style={{ display: 'flex', flexDirection: 'row' }}>
			<div style={{ display: 'flex', flex: 2 }}>{title}</div>
			<div style={{ display: 'flex', flex: 2 }}>{this.bonusFormat(bonus)}</div>
			<div style={{ display: 'flex', flex: 1 }}>+{value}%</div>
		</div>
	}

	skillTextFormat = (skill) => {
		return <div style={{ display: 'flex', flexDirection: 'row' }}>
			<div style={{ display: 'flex', flex: 2 }}></div>
			<div style={{ display: 'flex', flex: 2 }}>{skill.name}</div>
			<div style={{ display: 'flex', flex: 1 }}>x{(skill.bonus).toString()}</div>
		</div>
	}

	numberDigit = (num) => {
		let n = num
		if (n < 1000n)
			return 0
		while (n >= 1000n)
			n /= 1000n
		if (n >= 100n)
			return 1
		if (n >= 10n)
			return 2
		return 3
	}

	updateFollower = (value) => {
		this.props.updateData({
			follower: this.props.data.follower + (value * this.props.data.incByClic),
			clicCount: this.props.data.clicCount + 1n
		})
	}

	Textbox = ({ children }) => {
		return (
			<div style={{ margin: 40, marginBottom: 0, backgroundColor: '#dbd56e', height: 150, display: 'flex', padding: 5 }}>
				<div style={{ color: '#ffffff', backgroundColor: '#2a2a2a', display: 'flex', flexDirection: 'column', overflowY: 'hidden', justifyContent: 'flex-end', flex: 1, fontSize: 18, padding: 10 }}>
					{children}
				</div>
			</div>
		)
	}

	render() {
		return (
			<div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
				<div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
					<div style={{ display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'auto', paddingLeft: 10 }}>
						<div style={{ fontSize: 32, padding: 20 }}>
							Stats
						</div>
						{
							this.props.store.map((value, key) => {
								if (this.props.data[`storeCount${key}`])
									return (
										<div>
											{
												Object.keys(this.props.store[key].print).map((val, index) => (
													<div key={index}>
														{this.statsTextFormat(((index) ? '' : this.props.store[key].name), val, (this.props.store[key].print[val] * this.props.data[`storeCount${key}`]).toString())}
													</div>
												))
											}
											{
												(this.props.data[`skillLevel${key}`] && this.props.data[`skillLevel${key}`] <= this.props.skill[key].length) ?
												this.skillTextFormat(this.props.skill[key][this.props.data[`skillLevel${key}`] - 1n]) : <div/>
											}
										</div>
									)
								return <div key={key} />
							})
						}
					</div>
					<div style={{ display: 'flex', height: 150, alignItems: 'center', justifyContent: 'center' }}>
						<div style={{ borderStyle: 'solid', backgroundColor: '#ffffff', borderWidth: 2, borderColor: '#6d6d6d', fontSize: 28, paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							Number of follower
							<div style={{ fontSize: 32, fontWeight: 600 }}>
								{(this.props.data.follower / 1000n).toLocaleString('en-US', { notation: (this.props.data.follower / 1000000000000000000n > 0n) ? 'scientific' : 'compact', maximumFractionDigits: this.numberDigit(this.props.data.follower / 1000n) })}
							</div>
						</div>
					</div>
					<div style={{ display: 'flex', height: 150, alignItems: 'center', justifyContent: 'center', border: 0, borderTop: 1, borderStyle: 'solid', borderColor: '#6d6d6d' }}>
						<div style={{ borderStyle: 'solid', backgroundColor: '#ffffff', borderWidth: 2, borderColor: '#6d6d6d', fontSize: 28, paddingRight: 20, paddingLeft: 20, paddingTop: 10, paddingBottom: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							Influence
							<div style={{ fontSize: 32, fontWeight: 600 }}>
								{(this.props.data.influence / 1000n).toLocaleString('en-US', { notation: (this.props.data.influence / 1000000000000000000n > 0n) ? 'scientific' : 'compact', maximumFractionDigits: this.numberDigit(this.props.data.influence / 1000n), minimumFractionDigits: this.numberDigit(this.props.data.influence / 1000n) })}
							</div>
						</div>
					</div>
				</div>

				<div style={{ backgroundImage: `url(${getBackground(this.props.data)})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: '50% 100%', imageRendering: 'pixelated', display: 'flex', flex: 1.5, backgroundColor: '#CDEBF2', color: '#1a1a1a', flexDirection: 'column' }}>
					<this.Textbox>
						{
							this.props.messageList.map((text, key) => (
								<div key={key} style={{ display: 'flex' }}>{text}</div>
							))
						}
					</this.Textbox>

					<div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
						<button className="inc-button" onClick={() => { this.updateFollower(1n) }} />
					</div>
				</div>
				<div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
					<div style={{ display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'auto' }}>
						{
							this.props.store.map((value, key) => (
								<StoreOption key={key} updateData={this.props.updateData} name={value.name} base={value.base} picture={value.picture} count={this.props.data[`storeCount${key}`]} onBuy={value.onBuy} num={key} influence={this.props.data.influence} description={value.description} />
							))
						}
					</div>

					<div style={{ display: 'flex', height: 3, border: 0, borderTop: 1, borderBottom: 1, borderStyle: 'solid', borderColor: '#6d6d6d', backgroundColor: '#6d6d6d' }} />
					<div style={{ display: 'flex', flexDirection: 'column', height: 200, overflowY: 'auto' }}>
						<div style={{ fontSize: 32, padding: 20 }}>
							Upgrades
						</div>
						<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
							{
								this.props.skill.map((value, key) => (
									<SkillOption key={key} updateData={this.props.updateData} data={this.props.data} skill={value} num={key} store={this.props.store[key]} />
								))
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}